import { z } from 'zod';

export const contactFormSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  email: z.string().email({ message: 'Invalid email address' }),
  category: z.string().min(1, { message: 'Category is required' }),
  message: z.string().min(1, { message: 'Message is required' }),
  report_reason: z.string().optional(),
  phone_number: z.string().optional(),
});

export type ContactFormSchema = z.infer<typeof contactFormSchema>;
